/* eslint-disable */
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Collapse,
} from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp, CloseFullscreen } from '@material-ui/icons';
import { CurrencyFormatter } from '../Utils/CurrencyFormatter';

const TablaFinanciera = ({ data, openTable, title }) => {
  console.log("TablaFinancieraData", data)
  const { header, rows } = data;
  const [expandedRows, setExpandedRows] = useState([]);
  const [currentTable, setCurrentTable] = useState(true);

  const handleRowToggle = (rowIndex) => { 
    const newExpandedRows = [...expandedRows];
    if (expandedRows.includes(rowIndex)) {
      newExpandedRows.splice(newExpandedRows.indexOf(rowIndex), 1);
    } else {
      newExpandedRows.push(rowIndex);
    }
    setExpandedRows(newExpandedRows);
  };

  const getCellStyle = (isBold) => ({
    fontWeight: isBold ? 700 : 400, // 700 para negrita, 400 para normal
    // color: isBold ? 'black' : '#024788', // Azul si es negrita, negro si no
    //fontSize: isBold ? 'larger' : 'inherit', // Tamaño de fuente más grande si es negrita
  });

  const handleOpenTable = () => {
    // Trigger the boolean value and pass it to the parent component
    const newValue = !currentTable; // toggle the value
    setCurrentTable(newValue);
    openTable(newValue);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{ background: '#e7e8e8', color: '#42526E' }}>{title}</TableCell> {/* Columna de detalle*/}
            {header.map((item, index) => (
              <TableCell
                key={index}
                style={{ background: '#e7e8e8', color: index === 0 ? '#689DB8' : '#42526E', textAlign: index === 0 ? 'center' : 'right'}}
              >
                {item}
              </TableCell>
            ))}
            <TableCell style={{background: '#e7e8e8', color: '#sets', padding: '16px 0', textAlign: 'center'}}>
              <IconButton onClick={handleOpenTable}>
                <CloseFullscreen fontSize={"small"} sx={{ color: "#42526E"}}/>
              </IconButton>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <TableRow>
                {row.data.map((cell, cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    style={{
                      background:
                          cellIndex === 0 && cell !== "" ? '#EDF4FC' : cellIndex === 1 ? '#689DB8' : 'white',
                      fontWeight: row.bold || cellIndex === 0 || cellIndex === 1 ? 'bold' : 'bold',
                      color: row.bold || cellIndex === 0 ? 'black' : cellIndex === 1 ? 'white' : '#024788',
                      textAlign: typeof cell === 'number' ? 'right' : cellIndex === 0 ? 'left' : 'justify'
                    }}
                  >
                    {cellIndex === 0 ? (
                      <Typography variant="inherit" className={row.bold ? 'bold' : ''}>
                        {cell}
                      </Typography>
                    ) : (
                      typeof cell === 'number' ? <CurrencyFormatter value={cell} /> : cell
                    )}
                  </TableCell>
                ))}
                <TableCell style={{ background: 'white', padding: '16px 0' }}></TableCell>
              </TableRow>
              {row.subRows &&
                row.subRows.map((subRow, subRowIndex) => (
                  <TableRow key={`${rowIndex}-${subRowIndex}`}>
                    {subRow.data.map((subCell, subCellIndex) => (
                      <TableCell
                        key={subCellIndex}
                        style={{
                          background:
                              subCellIndex === 0 ? '#EDF4FC' : subCellIndex === 1 ? '#89B8CF' : 'white',
                          fontWeight: row.bold || subCellIndex === 0 || subCellIndex === 1 ? 'bold' : 'bold',
                          color: row.bold || subCellIndex === 0 ? 'black' : subCellIndex === 1 ? 'white' : '#024788',
                          textAlign: typeof subCell === 'number' ? 'right' : subCellIndex === 0 ? 'left' : 'justify'
                        }}
                      >
                        <div>
                          <CurrencyFormatter value={subCell} />
                          {subRow.bold}
                        </div>
                      </TableCell>
                    ))}
                    <TableCell style={{ background: 'white', padding: '16px 0' }}></TableCell>
                  </TableRow>
                ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TablaFinanciera;
